import { render, staticRenderFns } from "./UserEditModal.vue?vue&type=template&id=878bb018&scoped=true&"
import script from "./UserEditModal.vue?vue&type=script&lang=js&"
export * from "./UserEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "878bb018",
  null
  
)

export default component.exports